import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaHeart, FaShareAlt, FaBookmark } from "react-icons/fa";
import shopify from "../../Images/shopify.png";
import "../../Frontend/style.css";

const PostStyle1 = ({ block, viewMode }) => {
  const [likes, setLikes] = useState(Number(block.likes || 0));
  const [liked, setLiked] = useState(() => JSON.parse(localStorage.getItem(`liked_${block.id}`)) || false);
  const [saves, setSaves] = useState(Number(block.saves || 0));
  const [saved, setSaved] = useState(() => JSON.parse(localStorage.getItem(`saved_${block.id}`)) || false);
  const [shares, setShares] = useState(Number(block.shares || 0));
  const [views, setViews] = useState(Number(block.views || 0));
  const [videoVisible, setVideoVisible] = useState(false); // Lazy loading for videos
  const [videoLoaded, setVideoLoaded] = useState(false); // For tracking actual video load
  const [hover, setHover] = useState("no"); // Hover state: "yes" or "no"
  const [loaded, setLoaded] = useState(false); // For bypassing lazy loading and skeleton effects
  const videoRef = useRef(null); // Reference to the video element

  const navigate = useNavigate();

  useEffect(() => {
    if (liked) {
      localStorage.setItem(`liked_${block.id}`, JSON.stringify(liked));
    } else {
      localStorage.removeItem(`liked_${block.id}`);
    }

    if (saved) {
      localStorage.setItem(`saved_${block.id}`, JSON.stringify(saved));
    } else {
      localStorage.removeItem(`saved_${block.id}`);
    }
  }, [liked, saved]);

  useEffect(() => {
    // Only set up observer if video exists
    if (block.video_path) {
      if (hover === "yes") {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setTimeout(() => {
                  setLoaded(true);
                  setVideoVisible(true);
                }, 600);
              }
            });
          },
          { threshold: 0.5 }
        );

        if (videoRef.current) {
          observer.observe(videoRef.current);
        }

        return () => {
          if (videoRef.current) {
            observer.unobserve(videoRef.current);
          }
        };
      } else {
        setLoaded(true);
        setVideoVisible(true);
      }
    }
  }, [hover, block.video_path]); // Add video_path to dependencies

  const handlePostClick = () => {
    const viewedPosts = JSON.parse(localStorage.getItem("viewedPosts")) || {};

    if (!viewedPosts[block.id]) {
      viewedPosts[block.id] = true;
      localStorage.setItem("viewedPosts", JSON.stringify(viewedPosts));
      setViews((prev) => prev + 1);
    }

    navigate(`/Shopify-custom-sections/post/${block.slug}`, { state: { post: block } });
  };

  const isNew = () => {
    const createdDate = new Date(block.created_at);
    const currentDate = new Date();
    const diffInDays = Math.floor((currentDate - createdDate) / (1000 * 60 * 60 * 24));
    return diffInDays <= 2;
  };

  return (
    <div
    className={`customer-block-card ${viewMode === "Cards" ? "minimal" : "detailed"}`}
    onClick={handlePostClick}
    onMouseEnter={() => block.video_path && setHover("yes")}
    onMouseLeave={() => block.video_path && setHover("no")}
  >
      {/* Header Section */}
      <div className="post-header">
        <div className="profile-cont11">
          <div className="profile-container">
            <div className="profile-initial">{block.name?.charAt(0).toUpperCase() || "?"}</div>
          </div>
          <div className="post-info">
            <h3 className="post-title">{block.name}</h3>
            <p className="post-source">Added by Xebrand and team</p>
            <div className="cout-view">
              <span className="viw-icnont">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z" fill="#8b51ff"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z" fill="#8b51ff"></path></svg>
              </span>
              <span className="count-text">{views} Views</span>
            </div>
          </div>
        </div>
        <div className="app-img">
          <img src={shopify} alt="App" className="circular-toggle-image" />
        </div>
      </div>

      {/* Updated Media Section */}
      <div className="customer-block-media" ref={videoRef}>
        {block.video_path ? (
          /* Show video toggle only if video exists */
          <>
            {hover === "no" ? (
              <img
                src={block.image_path || "/fallback-image.jpg"}
                alt={block.name || "Unnamed Block"}
                className="customer-block-image"
              />
            ) : (
              videoVisible && (
                <video
                  src={block.video_path}
                  autoPlay
                  loop
                  muted
                  className={`customer-block-video ${videoLoaded ? "loaded" : "hidden"}`}
                  onLoadedData={() => setVideoLoaded(true)}
                />
              )
            )}
          </>
        ) : (
          /* Always show image if no video */
          <img
            src={block.image_path || "/fallback-image.jpg"}
            alt={block.name || "Unnamed Block"}
            className="customer-block-image"
          />
        )}

        <div className="interaction-tools">
          {isNew() && (
            <div className="tags-cont">
              <span className="tag">New</span>
            </div>
          )}
        </div>
      </div>

      {/* Actions Section */}
      {viewMode === "Details" && (
        <div className="customer-block-actions">
          <button className={`like-button ${liked ? "liked" : ""}`}>
            <FaHeart /> {liked ? "Liked" : "Like"}
          </button>
          <button className="share-button">
            <FaShareAlt /> Share
          </button>
          <button className={`save-button ${saved ? "saved" : ""}`}>
            <FaBookmark /> {saved ? "Saved" : "Save"}
          </button>
        </div>
      )}
    </div>
  );
};

export default PostStyle1;
